import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/oncommit.png";
import avatarVideo from "../../assets/bg/tratamiento-1-avatar.webm";
import avatarVideoMp4 from "../../assets/bg/tratamiento-1-avatar.mp4";
import manuelVideo from "../../assets/bg/tratamiento-1-manuel.webm";
import manuelVideoMp4 from "../../assets/bg/tratamiento-1-manuel.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario3Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	
	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const [canOpenDialog, setCanOpenDialog] = useState(false);

	const transcription = "Cuando escuché la palabra cáncer sentí que se me vino el mundo encima. Lo primero que pensé es en mi familia. Ya tengo diabetes, colesterol... Vivo tomando pastillas. Si hay un tratamiento que de verdad me ayude, quiero hacerlo. No quiero perder el tiempo, pero tampoco quiero quedar postrado, sin poder vivir mi vida."

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO3);
	};

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8, "violet");
	};

	const activeScenario = getScenarioNumByPath(location.pathname);
	
	useEffect(() => {
		const timer = setTimeout(() => setCanOpenDialog(true), 20000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "60%",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted={!canPlayWithSound}
							onEnded={() => setCanOpenDialog(true)}
							onError={() => setCanOpenDialog(true)}
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-end align-items-end bg-tratamiento-a h-100 px-5">
						<div className="recuadro recuadro-violet txtTexto1 w-100">
							<p>Has entrado a la siguiente sala.</p>
							<p>Manuel requiere una intervención adecuada. Entre las opciones disponibles, solo algunas conducirán al tratamiento adecuado. Es momento de aplicar tus conocimientos y tomar decisiones clínicas clave.</p>
							<div className="d-flex justify-content-center">
								<div
								    className={`button-escuchar-paciente button-escuchar-paciente-violet mt-4 mb-4 ${!canOpenDialog ? "is-disabled" : ""}`}
									aria-disabled={!canOpenDialog}
									onClick={canOpenDialog ? abrirModal : undefined}
									style={!canOpenDialog ? { pointerEvents: "none" } : undefined}
								>
									Escuchar al paciente
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario3Intro);
